import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "cleaning_services",
    title: "Intensive Top-to-Bottom Clean",
    description:
      "We cover all surfaces, fixtures, appliances, and often-missed areas in a thorough and systematic clean.",
  },
  {
    icon: "home_work",
    title: "Residential & Commercial",
    description:
      "Suitable for homes, offices, and commercial premises that need a thorough reset beyond regular upkeep.",
  },
  {
    icon: "today",
    title: "Scheduled or One-Off",
    description:
      "We offer deep cleaning as a standalone service or as a periodic add-on to your regular cleaning schedule.",
  },
  {
    icon: "groups",
    title: "Experienced Team",
    description:
      "Our team is equipped with professional-grade products and tools to handle even the most demanding cleans.",
  },
];

function DeepCleaning_Section1() {
  return <ServiceHighlights title="Why Choose Our Deep Cleaning Service?" items={items} />;
}

export default DeepCleaning_Section1;
